// extracted by mini-css-extract-plugin
export default {"colorItem":"_kKWcR5NvUALks0lqj_z","colorItemIsActive":"xhlorvfOa2gKGXsoOhE6","colorItemColor":"AyLXLpSr1H4YDXPguRfe","colorItemColorCheckbox":"rwuJTvP0eckYcBJF4drQ"};